import { useState, useEffect, useRef } from "react";
import getDataFromApi from "./getDataFromApi";

export default function useFetch(path, method, type, body) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [fetchNow, setFetchNow] = useState(false);
  const [alert, setAlert] = useState();
  const [error, setError] = useState(null);
  const [status, setStatus] = useState(null);
  const silentRef = useRef(false);

  useEffect(() => {
    if (!path) {
      setLoading(false);
      return;
    }

    const controller = new AbortController();
    const { signal } = controller;
    const silent = silentRef.current;

    let timeoutId;

    const doFetch = async () => {
      if (!silent) setLoading(true);
      setError(null);
      setStatus(null);

      const url = `${window.ENV.API_URL}/${path}`;

      try {
        const result = await getDataFromApi(url, method ?? "GET", body, type, signal);

        // If you also want status, you’d need getDataFromApi to return it.
        // Keeping your existing state shape: status is best set inside getDataFromApi
        // by throwing {status:...}. For success, you can just null/200:
        setStatus(200);

        setData(result);
        setError(null);
      } catch (e) {
        if (signal.aborted) return;

        const normalizedError =
          e?.status != null ? e : { ...e, status: 0, type: "NETWORK" };

        setError(normalizedError);
        setStatus(normalizedError.status ?? null);

        setAlert({ message: normalizedError.message, status: "error" });

        timeoutId = setTimeout(() => setAlert(null), 2000);
      } finally {
        silentRef.current = false;
        if (!signal.aborted) setLoading(false);
      }
    };

    doFetch();

    return () => {
      controller.abort();
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [method, path, type, body, fetchNow]);

  function refetch(options = {}) {
    silentRef.current = Boolean(options?.silent);
    setFetchNow((prev) => !prev);
  }

  function setLoad(value) {
    setLoading(value);
  }

  return { loading, data, error, refetch, status, setLoad, setData, alert };
}
